module.exports = __webpack_public_path__ + "img/7.0885f7e7.png";